module.exports = __webpack_public_path__ + "static/img/hellix_double.1e99f511.png";